var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tile", { staticClass: "tenders", attrs: { link: "tenders" } }, [
    _c(
      "div",
      {
        staticClass: "tenders__header",
        attrs: { slot: "tileHeader" },
        slot: "tileHeader",
      },
      [
        _c("tile-title", { attrs: { icon: "gavel" } }, [_vm._v("Тендеры")]),
        _vm._v(" "),
        _c(
          "app-switcher",
          {
            attrs: {
              leftClickHandler: _vm.toggle,
              rightClickHandler: _vm.toggle,
              isLeftDisabled: !_vm.participantYears.length,
              isRightDisabled: !_vm.customerYears.length,
            },
          },
          [
            _c("span", { attrs: { slot: "leftValue" }, slot: "leftValue" }, [
              _vm._v("Участник"),
            ]),
            _vm._v(" "),
            _c("span", { attrs: { slot: "rightValue" }, slot: "rightValue" }, [
              _vm._v("Заказчик"),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tenders__content",
        attrs: { slot: "tileContent" },
        slot: "tileContent",
      },
      [
        _c(
          "app-transition",
          {
            attrs: {
              showLeftIf: _vm.type === "participants",
              showRightIf: _vm.type === "customers",
            },
          },
          [
            _c("participant", {
              ref: "participant",
              attrs: { slot: "left" },
              slot: "left",
            }),
            _vm._v(" "),
            _c("customer", {
              ref: "customer",
              attrs: { slot: "right" },
              slot: "right",
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isModal
          ? _c("tenders-modal", { attrs: { title: _vm.title } })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tenders__footer",
        attrs: { slot: "tileFooter" },
        slot: "tileFooter",
      },
      [
        _c("tile-print-pdf", {
          attrs: {
            html: _vm.htmlString,
            title: _vm.title,
            filename: "Tenders",
            printStyle: _vm.printStyle,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }